function initPrefireSolo(scope=document){
  scope.querySelectorAll('[data-pf-pdp]').forEach(root=>{
    if(root.dataset.pfReady==='true')return;
    root.dataset.pfReady='true';
    const buttons=[...root.querySelectorAll('[data-pf-variant]')];
    const mainInput=root.querySelector('[data-pf-variant-input]');
    const stickyInput=root.querySelector('[data-pf-sticky-variant-input]');
    const qty=root.querySelector('[data-pf-quantity]');
    const stickyQty=root.querySelector('[data-pf-sticky-quantity]');
    const atc=root.querySelector('[data-pf-atc]');
    const atcLabel=root.querySelector('[data-pf-atc-label]');
    const stickyAtc=root.querySelector('[data-pf-sticky-atc]');
    const stickyLabel=root.querySelector('[data-pf-sticky-label]');
    const stickyTitle=root.querySelector('[data-pf-sticky-title]');
    const stickyPrice=root.querySelector('[data-pf-sticky-price]');
    const stickyDetail=root.querySelector('[data-pf-sticky-detail]');
    const stickyThumb=root.querySelector('[data-pf-sticky-thumb]');
    const hero=root.querySelector('[data-pf-hero-image]');
    const statuses=[...root.querySelectorAll('[data-pf-status]')];
    const packs=[...root.querySelectorAll('[data-pf-pack]')];
    const availability=root.querySelector('[data-pf-availability]');
    const guaranteeLabel=availability?.dataset.pfGuaranteeLabel||'';
    const initialButton=buttons.find(item=>item.getAttribute('aria-checked')==='true');
    const cardPrice=root.querySelector('[data-solo-price]');
    const cardCompare=root.querySelector('[data-solo-compare]');
    const cardBoxline=root.querySelector('[data-solo-boxline]');
    const cardDotline=root.querySelector('[data-solo-dotline]');
    const addToCartLabel=atc?.dataset.addToCartLabel||'Add to cart';

    const select=(button,historyMode='none')=>{
      if(!button)return;
      const id=button.dataset.variantId;
      const available=button.dataset.variantAvailable==='true';
      const title=button.dataset.variantTitle||'';
      const displayTitle=title==='3V1'?'3V1 Bundle':title;
      const price=button.dataset.variantPrice||'';
      buttons.forEach(item=>{
        const active=item===button;
        item.classList.toggle('is-selected',active);
        item.classList.toggle('solo-pill--active',active);
        item.tabIndex=active?0:-1;
        item.setAttribute('aria-checked',active?'true':'false');
      });
      [mainInput,stickyInput].forEach(input=>{if(input)input.value=id;});
      statuses.forEach(el=>el.textContent=available?'In stock':'Sold out');
      packs.forEach(el=>el.textContent=button.dataset.variantPack||'20 Pack');
      if(atc)atc.disabled=!available;
      if(stickyAtc)stickyAtc.disabled=!available;
      if(atcLabel)atcLabel.textContent=available?addToCartLabel+' · '+price:'Sold out';
      if(stickyLabel)stickyLabel.textContent=available?addToCartLabel+' · '+price:'Sold out';
      if(stickyTitle)stickyTitle.textContent=displayTitle;
      if(stickyPrice)stickyPrice.textContent=price;
      /* OCT 5 (pdp): sticky bar pouch count + colourway thumbnail (hi-res map rendered by the section) */
      if(stickyDetail)stickyDetail.textContent=button.dataset.pouches||'20 Pouches';
      if(stickyThumb){
        const map=[...root.querySelectorAll('[data-pf-pdp-variant-images] [data-variant-id]')].find(el=>el.dataset.variantId===id);
        if(map&&map.dataset.thumb){
          if(stickyThumb.getAttribute('src')!==map.dataset.thumb)stickyThumb.src=map.dataset.thumb;
          if(map.dataset.thumbSrcset)stickyThumb.srcset=map.dataset.thumbSrcset;else stickyThumb.removeAttribute('srcset');
        }
      }
      if(availability)availability.textContent=available?('IN STOCK'+(guaranteeLabel?' · '+guaranteeLabel.toUpperCase():'')):'SOLD OUT';
      if(cardPrice&&button.dataset.cardPrice)cardPrice.textContent=button.dataset.cardPrice;
      if(cardCompare){
        const showCompare=button.dataset.hasCompare==='1'&&button.dataset.cardCompare&&button.dataset.cardCompare!==button.dataset.cardPrice;
        cardCompare.hidden=!showCompare;
        if(showCompare)cardCompare.textContent=button.dataset.cardCompare;
      }
      if(cardBoxline)cardBoxline.textContent=(button.dataset.boxes||'1 Box')+'     '+(button.dataset.pouches||'20 Pouches')+'      '+(button.dataset.hours||'160 hrs');
      if(cardDotline)cardDotline.textContent=(button.dataset.priceShort||'')+' ..... '+(button.dataset.perPouch||'')+' / SOLO Pouch';
      root.querySelectorAll('[data-pf-price-state]').forEach(el=>el.classList.toggle('is-hidden',el.dataset.pfPriceState!==id));
      root.querySelectorAll('[data-pf-stats-state]').forEach(el=>el.classList.toggle('is-hidden',el.dataset.pfStatsState!==id));
      if(hero&&button.dataset.variantImage){
        hero.src=button.dataset.variantImage;
        hero.removeAttribute('srcset');
        hero.alt=button.dataset.variantImageAlt||displayTitle;
      }
      if(historyMode!=='none'&&id){
        const url=new URL(location.href);
        url.searchParams.set('variant',id);
        if(historyMode==='push')history.pushState({variant:id},'',url);
        else history.replaceState({variant:id},'',url);
      }
    };

    buttons.forEach((button,index)=>{
      button.addEventListener('click',()=>select(button,'push'));
      button.addEventListener('keydown',event=>{
        const offset={ArrowRight:1,ArrowDown:1,ArrowLeft:-1,ArrowUp:-1}[event.key];
        if(offset===undefined&&event.key!=='Home'&&event.key!=='End')return;
        event.preventDefault();
        const next=event.key==='Home'?buttons[0]:event.key==='End'?buttons[buttons.length-1]:buttons[(index+offset+buttons.length)%buttons.length];
        select(next,'push');next.focus();
      });
    });
    root.querySelector('[data-pf-minus]')?.addEventListener('click',()=>{
      if(!qty)return;
      qty.value=String(Math.max(1,Number(qty.value||1)-1));
      if(stickyQty)stickyQty.value=qty.value;
      qty.dispatchEvent(new Event('change',{bubbles:true}));
    });
    root.querySelector('[data-pf-plus]')?.addEventListener('click',()=>{
      if(!qty)return;
      qty.value=String(Math.max(1,Number(qty.value||1)+1));
      if(stickyQty)stickyQty.value=qty.value;
      qty.dispatchEvent(new Event('change',{bubbles:true}));
    });
    qty?.addEventListener('change',()=>{qty.value=String(Math.max(1,Math.trunc(Number(qty.value)||1)));if(stickyQty)stickyQty.value=qty.value;});

    const selectFromUrl=()=>{
      const id=new URL(location.href).searchParams.get('variant');
      const button=id?buttons.find(item=>item.dataset.variantId===id):initialButton;
      if(button)select(button,'none');
    };
    window.addEventListener('popstate',selectFromUrl);
    selectFromUrl();
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initPrefireSolo(document),{once:true});
else initPrefireSolo(document);
document.addEventListener('shopify:section:load',event=>initPrefireSolo(event.target));
